const ABFieldFileCore = require("../../core/dataFields/ABFieldFileCore");
module.exports = class ABFieldFile extends ABFieldFileCore {};
